import React from 'react';

const CheckPermissionsError: React.FC = React.memo(function CheckPermissionsError() {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h5 className="mb-l5-16">Allow Lumen5 to record</h5>
            <p>
                Looks like we don&apos;t have permission to access your camera and microphone.{' '}
                <br /> Enable it in the browser to start recording.
            </p>
            <img
                alt="Device permission denied"
                src="https://cdn.lumen5.com/lumen5-site-images/record-your-screen-error.png"
                className="w-75"
            />
        </div>
    );
});

export default CheckPermissionsError;
